import api from './client'

export interface NerExtractRequest {
  dataset_id: string
  max_rows?: number
  row_selection?: 'top' | 'random'
  entity_types?: string[]
}

export interface NerEntity {
  entity: string
  type: string
  count: number
  pmcid_count: number
  pmcids: string[]
  examples: { pmcid: string; sentence: string }[]
}

export interface NerResults {
  entities: NerEntity[]
  type_counts: Record<string, number>
  entity_types: string[]
  sentences_scanned: number
  rows_total: number
}

export interface ExtractionResponse {
  analysis_id: string
  user_id: string
  session_id?: string
  dataset_id?: string
  name: string
  analysis_type: string
  params?: Record<string, any>
  results?: NerResults
  status: string
  error_message?: string
  created_at: string
}

export interface ExtractionListItem {
  analysis_id: string
  session_id?: string
  dataset_id?: string
  name: string
  analysis_type: string
  status: string
  error_message?: string
  created_at: string
}

export const entitiesApi = {
  extract: (data: NerExtractRequest) =>
    api.post<{ analysis_id: string; status: string; message: string }>('/entities/extract', data),
  getExtraction: (id: string) => api.get<ExtractionResponse>(`/entities/extract/${id}`),
  listExtractions: (sessionId?: string) =>
    api.get<ExtractionListItem[]>('/entities/extractions', {
      params: sessionId ? { session_id: sessionId } : undefined,
    }),
  cancel: (id: string) => api.post<{ message: string }>(`/entities/extract/${id}/cancel`, {}),
  delete: (id: string) => api.delete<{ message: string }>(`/entities/extract/${id}`),
}
